import { useState } from 'react'
import AdminClientCard from './AdminClientCard'

export default function AdminClients({clients, theme}) {
  const [clientSearchTerm, setClientSearchTerm] = useState("");
  const deployClients = ()=>{
    const filtered = clientSearchTerm==="" ? 
    clients : 
    clients.filter((client)=>{
      return client.name.includes(clientSearchTerm.trim()) || client.email.includes(clientSearchTerm.trim()) || client.phone.includes(clientSearchTerm.trim())
    })
    return filtered.length > 0 ? filtered.map((client, inx)=>{
      return <AdminClientCard key={`adminClientCard_inx_${inx}`} client={client} theme={theme}/>
    }) : <h1 style={{color:theme.accent_color, textShadow:`1px 1px 3px ${theme.primary_color}`}}>לא נמצאו לקוחות</h1>;
  }
  return (
    <div className='adminClients'>
      <h2 style={{margin:"0",color:theme.accent_color, textShadow:`2px 2px 4px ${theme.primary_color}`, fontSize:"50px"}}>הלקוחות שלי</h2>
      <input className='adminClients_input' type='text' placeholder='חפש לקוח...'  onChange={(e)=>{setClientSearchTerm(e.target.value)}}/>
      <div className='adminClients_list'>
        {deployClients()}
      </div>
    </div>
  )
}
